'use strict';

const _ = require('underscore');
const ContentVersionFactory = require('data/domain/factory/content/version');
const ContentVersionAPI = require('data/infra/api/content/version');
const VersionCollection = require('data/domain/collection/content/version');

class Repository {
    constructor(project, content) {
        this._project = project;
        this._content = content;
        this._versions = new VersionCollection();
    }

    add(version) {
        this._versions.add(version, {merge: true});
    }

    on(event, callback) {
        this._versions.on(event, callback);
    }

    get() {
        return this._versions;
    }

    fetchByID(versionID) {
        return new Promise((resolve, reject) => {
            const id = `DataContent:${this._content.id}/Version:${versionID}`;
            if(this._versions.get(id)) {
                resolve(this._versions.get(id));
            } else {
                const version = ContentVersionAPI.fetchVersionByID(
                    this._project.id, this._content.id, versionID
                ).then(versionJSON => {
                    versionJSON._content = this._content;
                    return this.build(versionJSON);
                }).then(version => {
                    this.add(version);
                    return this._versions.get(id);
                }, reject);
                resolve(version);
            }
        });
    }

    getNext(limit) {
        return new Promise((resolve, reject) => {
            ContentVersionAPI.getNextVersions(
                this._project.id, this._content.id, limit
            ).then(versionsJSON => {
                Promise.all(
                    _.map(versionsJSON, j => {
                        j._content = this._content;
                        return this.build(j);
                    })
                ).then(versions => {
                    _.each(versions, v => {
                        this.add(v);
                    });
                    resolve(this._versions);
                });
            }, reject);
        });
    }

    hasNext() {
        return ContentVersionAPI.hasNextVersions(this._project.id, this._content.id);
    }

    deleteVersions() {
        this._versions.each(version => {
            version.delete();
        });
        return this._versions;
    }

    build(versionJSON) {
        return new ContentVersionFactory(this._project).build(versionJSON);
    }

}

const repositories = {};

const find = function(content) {
    const project = content.getProject();
    const key = `${project.id}:${content.id}`;

    let r = repositories[key];
    if (!r) {
        r = new Repository(project, content);
        repositories[key] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./data/domain/repository/content/version.js